import { useContext, useEffect, useState } from 'react'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { SEL_CURRENT_LEVEL_CONFIG } from '../../b.providers/ScenesProvider/selectors'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { SEL_BATTLE_STATE } from '../../c.managers/LevelManager/selectors'
import { BATTLE_STATES, COMMANDERS, Spell } from '../../c.managers/LevelManager/store.d'
import { SEL_LEVEL_SUMMARY, SEL_TREASURES } from '../../c.managers/TerrainManager/selectors'
import BaseWindow from './components/BaseWindow/BaseWindow'
import Overlay from './components/Overlay/Overlay'
import { NavContext, NavContextType, useNav } from './ScreensNav'

const NewSpellScreen = ({ ctx }: { ctx: NavContextType }) => {
  const { dismiss, nav } = ctx
  const config = useScenesStore(SEL_CURRENT_LEVEL_CONFIG)
  const newSpell = config.newSpell as Spell
  
  return (
    <>
      <BaseWindow show>
        <div className={`body-container`}>
          <div className="header-container">
            <span>New Item</span>
          </div>
          <div className="body-content">
            <div className="body-row no-bottom-line">
              <span style={{ fontSize: '4.5vh' }}>Spell available</span>
            </div>
            <div
              className="body-row"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg")`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                height: '50%',
                border: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'black',
              }}
            >
              <span data-ico={newSpell.icon} className="spell-card-text" style={{
                height: 'auto',
                marginTop: '20px',
                textShadow: 'none',
                fontSize: '1em',
              }}>
                {newSpell.name}
              </span>
              <span
                style={{
                  textAlign: 'center',
                  width: '45%',
                  fontSize: '0.65em',
                  lineHeight: '0.75em',
                  textShadow: 'none', //'1px 1px 0 #430064, 2px 2px 0 #430064, 0 0 0 #FFF955'
                }}
              >
                {newSpell.description}
              </span>
            </div>
            <a
              className="body-row no-bottom-line"
              onClick={() => {
                nav('/next')
              }}
            >
              <div className="theme-button button-orange-big">NEXT</div>
            </a>
          </div>
        </div>
      </BaseWindow>
    </>
  )
}

export default NewSpellScreen
